module.exports = __webpack_public_path__ + "img/bgmad6.02b5de4b.jpg";